import { useLocalization } from "@fluent/react";
import React, { useContext, useMemo } from "react";
import { getCountryOptions } from "byzantine/src/l10n/Country";
import { getSelectedLocale } from "byzantine/src/l10n/InstanceHelpers";
import { Combobox, ContextForm } from "cerulean";
import type { EnrollmentFormContext } from "../types";

const PassportCountryField = () => {
  const { l10n } = useLocalization();
  const { metadata, dispatchMetadata } = (useContext(ContextForm.FormContext) ??
    {}) as EnrollmentFormContext;
  const selectedLocale = getSelectedLocale(l10n);
  const countries = useMemo(
    () =>
      getCountryOptions(selectedLocale).filter(
        (country) => country.code !== "US"
      ),
    [selectedLocale]
  );

  // Currently the only possible error is a missing passport country, so clearing upon any item
  // being selected is sufficient.
  const clearPassportCountryError = (nextPassportCountry?: string) => {
    if (!nextPassportCountry) return;

    const fieldMetadata = metadata?.passport_country;

    if (!fieldMetadata?.error) return;

    dispatchMetadata?.({
      type: "update",
      update: {
        ...metadata,
        passport_country: {
          ...fieldMetadata,
          error: undefined,
        },
      },
    });
  };

  return (
    <ContextForm.Field required key="passport_country">
      <Combobox
        field="passport_country"
        onChange={clearPassportCountryError}
        label={l10n.getString("label-passport-country")}
      >
        {countries.map((country) => (
          <Combobox.Item
            key={country.code}
            value={country.code}
            searchValue={country.name}
          >
            {country.name}
          </Combobox.Item>
        ))}
      </Combobox>
    </ContextForm.Field>
  );
};

export default PassportCountryField;
